/** Instagram Post — document knowledge definition. Pure data. */
export default {
  id: 'instagram-post',
  name: 'Instagram Post',
  description: 'A single-image feed post designed to stop the scroll and drive engagement.',
  purpose: 'Social Engagement & Promotion',
  recommendedSizes: [
    { name: 'Square', width: 1080, height: 1080, unit: 'px' },
    { name: 'Portrait', width: 1080, height: 1350, unit: 'px' },
  ],
  supportedOrientations: ['square', 'portrait'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Hook Visual', 'Headline', 'Supporting Text', 'CTA', 'Brand Handle'],
};
